/*
 ClioWidgetForm custom html element
 Build 1697032167
*/

class ClioWidgetForm extends HTMLElement {
  constructor() {
    super();
    const options = {
      'ticket': this.getOption('ticket', false),
      'review': this.getOption('review', false),
      'tag': this.getOption('tag', 'formticket'),
      'consent': this.getOption('consent', true),
      'marketing': this.getOption('marketing', true),
      'consent3': this.getOption('consent3', false),
      'consent4': this.getOption('consent4', false),
      'label': {
        'firstName': this.getOption('label-firstname', `Nome`),
        'lastName': this.getOption('label-lastname', `Cognome`),
        'email': this.getOption('label-email', `Indirizzo email`),
        'phone': this.getOption('label-phone', `Telefono`),
        'birthday': this.getOption('label-birthday', `Data di nascita`),
        'province': this.getOption('label-province', `Provincia`),
        'subject': this.getOption('label-subject', `La tua richiesta`),
        'rating': this.getOption('label-rating', `Il tuo voto`),
        'review': this.getOption('label-review', `La tua recensione`),
        'reviewOrder': this.getOption('label-review-order', `Lascia qui sotto le recensioni per il tuo ordine`),
        'reviewProduct': this.getOption('label-review-product', `La tua recensione per`),
        'reviewProductReviewed': this.getOption('label-review-product-reviewed', `Grazie per la tua recensione di`),
        'preferences': this.getOption('label-preferences', `Le tue preferenze`),
        'consent': this.getOption('label-consent', `Letta l’<a target="_blank" href="https://cliomakeupshop.com/pages/informativa-privacy">informativa sul trattamento dati</a>, vi fornisco il mio indirizzo email liberamente per ricevere la newsletter di ClioMakeUp.`),
        'marketing': this.getOption('label-marketing', ``),
        'consent3': this.getOption('label-consent3', ``),
        'consent4': this.getOption('label-consent4', `Letta l’<a target="_blank" href="https://cliomakeupshop.com/pages/informativa-privacy">informativa sul trattamento dati</a>, vi fornisco il mio indirizzo email liberamente per ricevere la newsletter di ClioMakeUp.`),
        'submit': this.getOption('label-submit', `Richiedi assistenza`),
        'mandatory': this.getOption('label-mandatory', `*I campi contrassegnati dall'asterisco sono obbligatori`),
      },
      'placeholder': {
        'firstName': this.getOption('placeholder-firstname', `Inserisci il tuo nome`),
        'lastName': this.getOption('placeholder-lastname', `Inserisci il tuo cognome`),
        'email': this.getOption('placeholder-email', `Inserisci la tua mail`),
        'phone': this.getOption('placeholder-phone', `Inserisci il tuo numero`),
        'province': this.getOption('placeholder-province', `Seleziona la provincia`),
        'subject': this.getOption('placeholder-subject', ``),
        'description': this.getOption('placeholder-description', `Raccontaci di piÃ¹ sul tuo problema...`),
        'preferences': this.getOption('placeholder-preferences', `Seleziona la/le linee di prodotti che piÃ¹ ti interessano`),
        'consent': this.getOption('placeholder-consent', `Letta l’informativa di cui sopra, presto il mio consenso a ricevere comunicazioni marketing generico da ClioMakeUp`),
        'marketing': this.getOption('placeholder-marketing', `Letta l’informativa di cui sopra, presto il mio consenso all’analisi delle mie preferenze, finalizzata a ricevere comunicazioni marketing personalizzate da ClioMakeUp`),
        'consent3': this.getOption('placeholder-consent3', `Il trattamento dei miei dati personali per le finalitÃ  di cui al paragrafo e 6.e, allo scopo di consentirmi lâ€™adesione ai programmi fedeltÃ  di ClioMakeUp, e a questâ€™ultima la gestione dei programmi stessi.`),
        'consent4': this.getOption('placeholder-consent4', `Il trattamento dei miei dati personali per le finalitÃ  di cui ai paragrafi 6.c e 6.f (rispondere alle tue richieste e fornirti un servizio personalizzato, come l'invio di  informazioni richieste e personalizzare l'esperienza online, offrendo contenuti e prodotti mirati ai tuoi interessi)`),
        'review': this.getOption('placeholder-review', `Inserisci il titolo della tua recensione`),
        'reviewText': this.getOption('placeholder-review-text', `Raccontaci qui la tua esperienza`),
        'reviewOrder': this.getOption('placeholder-review-order', `Puoi recensire uno, alcuni o tutti i prodotti acquistati con il tuo ordine. Seleziona un prodotto alla volta e inserisci il voto e la recensione nei campi corrispondenti.`),
      },
      'result': {
        'validation': this.getOption('result-validation', `Ricontrolla i tuoi dati! Ci sono degli errori nella tua richiesta.`),
        'validation_privacy': this.getOption('result-validation-privacy', `Il tuo consenso al trattamento dei dati e alla ricezione di comunicazioni Ã¨ obbligatorio per proseguire!`),
        'loading': this.getOption('result-loading', `Solo qualche secondo stiamo salvando la tua richiesta...`),
        'error': this.getOption('result-error', `Ci dispiace ma qualcosa Ã¨ andato storto nel salvataggio dei tuoi dati! Ti preghiamo di inviarci una mail a shop@cliomakeup.com`),
        'success': this.getOption('result-success', `Grazie $name, i tuoi dati sono stati salvati correttamente!`),
        'successTicket': this.getOption('result-success-ticket', `Grazie per averci contattato $name! Il Servizio Supporto Clienti di ClioMakeUpShop ha appena preso in carico la tua richiesta e riceverai una risposta a breve. Il numero di ticket della tua richiesta Ã¨: $ticket`),
        'successServerless': this.getOption('result-success-serverless', `Grazie $name i tuoi dati sono stati salvati correttamente!`),
        'successReviewOrder': this.getOption('result-success-review-order', `Grazie per la tua recensione! Se vuoi puoi lasciare altre recensioni per tutti i prodotti del tuo ordine.`),
        'successReviewOrderComplete': this.getOption('result-success-review-order-complete', `Grazie per la tua recensione! Hai recensito tutti i prodotti del tuo ordine!`),
      },
      'product': {
        'title': this.getOption('product-title', ''),
        'image': this.getOption('product-image', ''),
        'url': this.getOption('product-url', ''),
        'sku': this.getOption('product-sku', ''),
      },
      'defaults': this.getOption('defaults', {}),
      'readonly': this.getOption('readonly', []),
      'disable': this.getOption('disable', []),
      'optional': this.getOption('optional', []),
      'subjects': this.getOption('subjects', {}),
      'custom': this.getOption('custom', []),
      'preferences': this.getOption('preferences', {}),
      'provinces': {
        'AG': `Agrigento`,
        'AL': `Alessandria`,
        'AN': `Ancona`,
        'AO': `Aosta`,
        'AQ': `L'Aquila`,
        'AR': `Arezzo`,
        'AP': `Ascoli-Piceno`,
        'AT': `Asti`,
        'AV': `Avellino`,
        'BA': `Bari`,
        'BT': `Barletta-Andria-Trani`,
        'BL': `Belluno`,
        'BN': `Benevento`,
        'BG': `Bergamo`,
        'BI': `Biella`,
        'BO': `Bologna`,
        'BZ': `Bolzano`,
        'BS': `Brescia`,
        'BR': `Brindisi`,
        'CA': `Cagliari`,
        'CL': `Caltanissetta`,
        'CB': `Campobasso`,
        'CI': `Carbonia Iglesias`,
        'CE': `Caserta`,
        'CT': `Catania`,
        'CZ': `Catanzaro`,
        'CH': `Chieti`,
        'CO': `Como`,
        'CS': `Cosenza`,
        'CR': `Cremona`,
        'KR': `Crotone`,
        'CN': `Cuneo`,
        'EN': `Enna`,
        'FM': `Fermo`,
        'FE': `Ferrara`,
        'FI': `Firenze`,
        'FG': `Foggia`,
        'FC': `Forli-Cesena`,
        'FR': `Frosinone`,
        'GE': `Genova`,
        'GO': `Gorizia`,
        'GR': `Grosseto`,
        'IM': `Imperia`,
        'IS': `Isernia`,
        'SP': `La-Spezia`,
        'LT': `Latina`,
        'LE': `Lecce`,
        'LC': `Lecco`,
        'LI': `Livorno`,
        'LO': `Lodi`,
        'LU': `Lucca`,
        'MC': `Macerata`,
        'MN': `Mantova`,
        'MS': `Massa-Carrara`,
        'MT': `Matera`,
        'VS': `Medio Campidano`,
        'ME': `Messina`,
        'MI': `Milano`,
        'MO': `Modena`,
        'MB': `Monza-Brianza`,
        'NA': `Napoli`,
        'NO': `Novara`,
        'NU': `Nuoro`,
        'OG': `Ogliastra`,
        'OT': `Olbia Tempio`,
        'OR': `Oristano`,
        'PD': `Padova`,
        'PA': `Palermo`,
        'PR': `Parma`,
        'PV': `Pavia`,
        'PG': `Perugia`,
        'PU': `Pesaro-Urbino`,
        'PE': `Pescara`,
        'PC': `Piacenza`,
        'PI': `Pisa`,
        'PT': `Pistoia`,
        'PN': `Pordenone`,
        'PZ': `Potenza`,
        'PO': `Prato`,
        'RG': `Ragusa`,
        'RA': `Ravenna`,
        'RC': `Reggio-Calabria`,
        'RE': `Reggio-Emilia`,
        'RI': `Rieti`,
        'RN': `Rimini`,
        'RM': `Roma`,
        'RO': `Rovigo`,
        'SA': `Salerno`,
        'SS': `Sassari`,
        'SV': `Savona`,
        'SI': `Siena`,
        'SR': `Siracusa`,
        'SO': `Sondrio`,
        'TA': `Taranto`,
        'TE': `Teramo`,
        'TR': `Terni`,
        'TO': `Torino`,
        'TP': `Trapani`,
        'TN': `Trento`,
        'TV': `Treviso`,
        'TS': `Trieste`,
        'UD': `Udine`,
        'VA': `Varese`,
        'VE': `Venezia`,
        'VB': `Verbania`,
        'VC': `Vercelli`,
        'VR': `Verona`,
        'VV': `Vibo-Valentia`,
        'VI': `Vicenza`,
        'VT': `Viterbo`,
        'EUROPA': `Resto D'Europa`,
        },
      'serverless': true,
      'endpoint': {
        'server': `https://landing.cliomakeup.com/app/submit/`,
        'aws': `https://500ekj90bb.execute-api.eu-west-1.amazonaws.com/Prod/submitForm`,
      }
    }
    const style = {
      'size': this.getOption('fontsize', `20`),
      'colors': {
        'color1': this.getOption('color-1', `#ff8778`),
        'color2': this.getOption('color-2', `#EDABC2`),
        'color3': this.getOption('color-3', ``),
        'error': this.getOption('color-error', `#ff005e`),
        'success': this.getOption('color-success', `#edf9d1`),
        'success_border': this.getOption('color-success-border', `#a6e31b`),
        'text': this.getOption('color-text', `#000000`),
        'bg': this.getOption('color-bg', ``),
        'border': this.getOption('color-border', `#e9e9e9`),
        'placeholder': this.getOption('color-placeholder', `#bcbcbc`),
        'text_submit': this.getOption('color-submit', `#FFFFFF`)
      },
      'images': {
        'success': this.getOption('image-success', `https://landing.cliomakeup.com/wp-content/uploads/2021/07/status-success.gif`),
        'loading': this.getOption('image-success', `https://landing.cliomakeup.com/wp-content/uploads/2021/07/status-loading.gif`),
        'error': this.getOption('image-success', `https://landing.cliomakeup.com/wp-content/uploads/2021/07/status-error.gif`),
        'rating_0': this.getOption('image-rating-0', `https://landing.cliomakeup.com/wp-content/uploads/2022/07/rating_0.gif`),
        'rating_1': this.getOption('image-rating-1', `https://landing.cliomakeup.com/wp-content/uploads/2022/07/rating_1.gif`),
        'rating_2': this.getOption('image-rating-2', `https://landing.cliomakeup.com/wp-content/uploads/2022/07/rating_2.gif`),
        'rating_3': this.getOption('image-rating-3', `https://landing.cliomakeup.com/wp-content/uploads/2022/07/rating_3.gif`),
        'rating_4': this.getOption('image-rating-4', `https://landing.cliomakeup.com/wp-content/uploads/2022/07/rating_4.gif`),
        'rating_5': this.getOption('image-rating-5', `https://landing.cliomakeup.com/wp-content/uploads/2022/07/rating_5.gif`)
      }
    }
    this.attachShadow({mode: "open"});
    this.shadowRoot.innerHTML = this.getStyle(style) + this.getMarkup(options, style);
    this.submit(options)
    this.preload(style.images)
    this.addFonts()
    this.accordion()
  }
  getOption(attr, def) {
    let option = this.hasAttribute(attr) ? this.getAttribute(attr) : def
    if(["disable", "optional", "readonly"].includes(attr) && option !== def) { option = option.split(','); }
    if(["subjects", "preferences", "custom", "defaults"].includes(attr) && option !== def) { option = JSON.parse(option); }
    if(option=="false") { option = false
    } else if(option=="true") { option = true }
    return option == ' ' ? '' : option;
  }
  extraAttributes(name, defaults, readonly) {
    const def = this.getDefault(name, defaults)
    return def ? (def + this.maybeReadOnly(name, readonly)) : ''
  }
  getDefault(name, defaults, attr='value') {
    return name in defaults && defaults[name] ? (attr ? `${attr}="${defaults[name]}"` : defaults[name]) : ''
  }
  maybeReadOnly(name, readonly) {
    return readonly.includes(name) ? ` readonly` : ''
  }
  getStyle(styles) {
    const style = `<style>:host {
  display: block;
  contain: content;
}
form {
  --color1: ${ styles.colors.color1 };
  --color2: ${ styles.colors.color2 };
  --color3: ${ styles.colors.color3 };
  --color-text: ${ styles.colors.text };
  --color-bg: ${ styles.colors.bg };
  --color-border: ${ styles.colors.border };
  --color-error: ${ styles.colors.error };
  --color-success: ${ styles.colors.success };
  --color-success-border: ${ styles.colors.success_border };
  --color-placeholder: ${ styles.colors.placeholder };
  --color-text-submit: ${ styles.colors.text_submit };
  --size: ${ styles.size }px;
  --image-success: url(${ styles.images.success });
  --image-error: url(${ styles.images.error });
  --image-loading: url(${ styles.images.loading });
  display: flex;
  flex-wrap: wrap;
  max-width: 700px;
  font-size: var(--size);
  margin: 0 auto;
  justify-content: space-between;
  font-family: "Revalo Modern", inherit, sans-serif;
  text-align: left;
  padding-bottom: 2em;
  color: var(--color-text);
}
*,
*::before,
*::after {
  box-sizing: border-box;
}
form > * {
  width: 100%;
  margin-bottom: 1em;
}
form > *.half {
  width: 48%;
}
form > *.half.email-field:has(+ .consent) {
  width: 100%;
}
form > *.required > label:first-child:after {
  content: '*';
}
form > *.error {
  color: var(--color-error);
}
form > div p:first-child {
  margin-bottom: 0.5em;
}
form > div p:first-child:empty {
  display: none;
}
input[type=text]:focus,
input[type=email]:focus,
input[type=number]:focus,
input[type=tel]:focus,
select:focus,
textarea:focus {
  border-color: var(--color-text);
}
*.error input[type=text],
*.error input[type=email],
*.error input[type=number],
*.error input[type=tel],
*.error select,
*.error textarea {
  border-color: var(--color-error);
  color: var(--color-error);
}
*.error .input-wrap,
*.error .rating-emojis {
  border-color: var(--color-error);
}
*.error > span {
  border-color: var(--color-error) !important;
}
*.error input[type="radio"] + label:before,
*.error input[type="checkbox"] + label:before {
  transition: none;
}
label {
  margin-bottom: 0.2em;
  display: block;
}
a {
  color: inherit;
}
input[type=text],
input[type=email],
input[type=number],
input[type=tel],
select,
textarea,
.input-wrap {
  display: block;
  width: 100%;
  border-radius: 0.4em;
  padding: 0.6em 0.7em;
  line-height: 1.2;
  width: 100%;
  font-size: 1em;
  font-family: inherit;
  outline: 0;
  color: var(--color-text);
  border: 2px solid;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
  border-color: var(--color-border);
  background: none;
}
input::placeholder,
textarea::placeholder {
  color: var(--color-placeholder)
}
select.initial {
  color: var(--color-placeholder)
}
select {
  padding: 0.65em 0.7em;
  background: transparent url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='10' viewBox='0 0 18 12'%3E%3Cpolyline fill='none' stroke='${ styles.colors.color2.replace('#', '%23') }' stroke-width='3' points='3.462 -3.462 11.538 4.318 3.462 11.538' transform='rotate(90 7.692 5.538)'/%3E%3C/svg%3E%0A") no-repeat right 0.8em top 55%;
}
select[name="clio_subject"],
input[name^="clio_review_subject"] {
  border-radius: 0.4em 0.4em 0 0;
  padding: 0.7em 0.7em;
}
textarea {
  padding: 0.8em 0.7em;
}
input[readonly] {
  cursor: not-allowed;
  background: transparent url("data:image/svg+xml,%3Csvg fill='${ styles.colors.placeholder.replace('#', '%23') }' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 26' width='16px' height='16px'%3E%3Cpath d='M 16 0 C 13.789063 0 11.878906 0.917969 10.6875 2.40625 C 9.496094 3.894531 9 5.824219 9 7.90625 L 9 9 L 12 9 L 12 7.90625 C 12 6.328125 12.390625 5.085938 13.03125 4.28125 C 13.671875 3.476563 14.542969 3 16 3 C 17.460938 3 18.328125 3.449219 18.96875 4.25 C 19.609375 5.050781 20 6.308594 20 7.90625 L 20 9 L 23 9 L 23 7.90625 C 23 5.8125 22.472656 3.863281 21.28125 2.375 C 20.089844 0.886719 18.207031 0 16 0 Z M 9 10 C 7.34375 10 6 11.34375 6 13 L 6 23 C 6 24.65625 7.34375 26 9 26 L 23 26 C 24.65625 26 26 24.65625 26 23 L 26 13 C 26 11.34375 24.65625 10 23 10 Z M 16 15 C 17.105469 15 18 15.894531 18 17 C 18 17.738281 17.597656 18.371094 17 18.71875 L 17 21 C 17 21.550781 16.550781 22 16 22 C 15.449219 22 15 21.550781 15 21 L 15 18.71875 C 14.402344 18.371094 14 17.738281 14 17 C 14 15.894531 14.894531 15 16 15 Z'/%3E%3C/svg%3E") no-repeat right 0.8em top 55%;
}
textarea[name="clio_description"],
textarea[name^="clio_review_description"] {
  border-radius: 0 0 0.4em 0.4em;
  border-top: 0;
}
textarea[name="clio_description"]:focus,
textarea[name^="clio_review_description"]:focus {
  border-top: 2px solid;
  margin-top: -2px;
}
input[type=number] {
  -moz-appearance: textfield;
}
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.birthday input {
  display: inline-block;
  width: auto;
  border: none;
  padding-right: 0;
  min-width: 3em;
}
.birthday label {
  display: block;
  width: 100%;
}
.birthday span {
  display: flex;
  border: 2px solid;
  border-radius: 0.4em;
  align-items: center;
  border-color: var(--color-border);
}
p {
  font-size: 0.9em;
  margin-bottom: 0;
}
small {
  display: block;
  font-size: 0.8em;
  opacity: 0.75;
  margin-bottom: 0.5em;
}
small.mandatory {
  text-align: center;
}
.result {
  text-align: left;
  padding: 0.7em 0.7em 0.9em;
  font-size: 1em;
  border-radius: 0.5em;
  background: var(--color-error);
  color: white;
  position: sticky;
  bottom: -5px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.result:before {
  content: '';
  display: block;
  width: 4em;
  height: 4em;
  background-size: cover;
  background-image: var(--image-error);
  margin: -0.5em 0 -0.5em -0.5em;
  flex-shrink: 0;
}
.result:empty {
  display: none;
}
form.loading .result {
  background: transparent;
  color: var(--color-text);
  position: static;
  padding: 0;
}
form.loading .result:before {
  display: none;
}
form.success .result,
form.success-accordion .result {
  border: 2px solid;
  background: var(--color-success);
  border-color: var(--color-success-border);
  flex-direction: column;
  color: black;
  text-align: center;
  padding: 0.7em 1.5em 1.2em;
}
form.success .result:before,
form.success-accordion .result:before {
  background-image: var(--image-success);
  margin: 0 0 0.25em 0;
}
button {
  background-image: linear-gradient(-135deg, var(--color1) 0%, var(--color2) 100%);
  font-weight: bold;
  font-size: 1.2em;
  border: none;
  border-radius: 1em;
  color: var(--color-text-submit);
  line-height: 1;
  padding: 0.5em 0.5em 0.6em;
  text-transform: uppercase;
  font-family: inherit;
  margin-top: 0.8em;
  cursor: pointer;
  position: relative;
}
button:after {
  content: "";
  position: absolute;
  width: 4em;
  height: 4em;
  bottom: 0;
  left: 50%;
  margin-left: -2em;
  display: none;
  background-size: 114%;
  background-position: top center;
  background-repat: no-repeat;
}
form.loading button {
  color: transparent;
}
form.loading button:after {
  display: block;
  background-image: var(--image-loading);
}
input[type="radio"],
input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  visibility: hidden;
}
input[type="radio"] + label,
input[type="checkbox"] + label {
  display: flex;
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  margin-right: 1.5em;
  user-select: none;
}
input[type="checkbox"] + label {
  margin-right: 0;
  padding-right: 1.5em;
  width: 33%;
  align-items: flex-start;
}
input[type="radio"] + label:before,
input[type="checkbox"] + label:before {
  content: "";
  display: block;
  width: 1.1em;
  height: 1.1em;
  border-radius: 50%;
  border: 3px solid;
  margin-right: 0.5em;
  transform: scale(0.85);
  transition: all 0.15s ease-in-out;
  flex-shrink: 0;
}
input[type="checkbox"] + label:before {
  width: 1.3em;
  height: 1.3em;
  border-radius: 0.3em;
  margin-top: 0.1em;
  background-size: 80%;
  background-position: center;
  background-repeat: no-repeat;
}
input[type="radio"]:checked + label:before {
  background: radial-gradient(currentcolor 40%, rgba(255, 0, 0, 0) 41%);
  transform: scale(1);
}
input[type="checkbox"]:checked + label:before {
  transform: scale(1);
  background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 45.7 45.7' xml:space='preserve'%3E%3Cpath fill='${ styles.colors.text.replace('#', '%23') }' d='M20.687,38.332c-2.072,2.072-5.434,2.072-7.505,0L1.554,26.704c-2.072-2.071-2.072-5.433,0-7.504 c2.071-2.072,5.433-2.072,7.505,0l6.928,6.927c0.523,0.522,1.372,0.522,1.896,0L36.642,7.368c2.071-2.072,5.433-2.072,7.505,0 c0.995,0.995,1.554,2.345,1.554,3.752c0,1.407-0.559,2.757-1.554,3.752L20.687,38.332z'/%3E%3C/svg%3E%0A");
}
.rating,
.rating-stars {
  display: flex;
  justify-content: space-between;
  color: var(--color-placeholder);
}
.rating {
  padding: 0;
  margin-bottom: 0.2em;
}
.rating-stars {
  padding: 0.8em 1em;
  flex-grow: 1;
  justify-content: space-around;
  margin-top: -0.15em;
}
.rating-emojis {
  padding: 0 1em 0 0.8em;
  height: 3.4em;
  overflow: hidden;
  flex-shrink: 0;
  border-left: 2px solid var(--color-border);
  display: flex;
  align-items: flex-start;
}
.rating-emojis span {
  font-size: 1.6em;
  display: block;
  padding: 0.45em 0;
  text-align: right;
  letter-spacing: 0.08em;
}
.rating-emojis span:before {
  content: "?";
  opacity: 0.6;
  display: inline-block;
  min-width: 0.6em;
}
.rating-emojis span:after {
  content: "/5";
  font-size: 0.75em;
  opacity: 0.6;
}
.rating-emojis div {
  width: 3.4em;
  line-height: 0;
  transition: all 0.3s cubic-bezier(0.455, 0.030, 0.515, 0.955);
}
.rating-emojis div img {
  width: 3em;
  height: 3em;
  margin: 0.2em;
}
.rating-stars label {
  font-size: 1.8em;
  line-height: 1;
  opacity: 0.5;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  margin-bottom: 0;
}
.rating-stars label:hover {
  transform: scale(1.2);
}
.rating #rating-1:checked ~ .rating-stars label:nth-of-type(1),
.rating #rating-2:checked ~ .rating-stars label:nth-of-type(-n+2),
.rating #rating-3:checked ~ .rating-stars label:nth-of-type(-n+3),
.rating #rating-4:checked ~ .rating-stars label:nth-of-type(-n+4),
.rating #rating-5:checked ~ .rating-stars label {
  background: linear-gradient(-135deg,var(--color1), var(--color2));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  opacity: 1;
}
.rating #rating-1:checked ~ .rating-emojis span:before { content: "1"; }
.rating #rating-2:checked ~ .rating-emojis span:before { content: "2"; }
.rating #rating-3:checked ~ .rating-emojis span:before { content: "3"; }
.rating #rating-4:checked ~ .rating-emojis span:before { content: "4"; }
.rating #rating-5:checked ~ .rating-emojis span:before { content: "5"; }
.rating input:checked ~ .rating-emojis span:before {
  color: var(--color-text);
  opacity: 1;
}
.rating #rating-1:checked ~ .rating-emojis div { transform: translateY(-3.4em); }
.rating #rating-2:checked ~ .rating-emojis div { transform: translateY(-6.8em); }
.rating #rating-3:checked ~ .rating-emojis div { transform: translateY(-10.2em); }
.rating #rating-4:checked ~ .rating-emojis div { transform: translateY(-13.6em); }
.rating #rating-5:checked ~ .rating-emojis div { transform: translateY(-17em); }
.accordion_review {
  border: 2px solid;
  border-color: var(--color-border);
  margin-bottom: -2px;
  position: relative;
  display: block;
  z-index: 1;
  background: var(--color-bg);
  transition: transform 0.15s ease-in-out;
}
.accordion_review:first-child {
  border-radius: 0.4em 0.4em 0 0;
  margin-top: 0 !important;
}
.accordion_review:last-child {
  border-radius: 0 0 0.4em 0.4em;
  margin-bottom: 0 !important;
}
.accordion_review:only-child {
  border-radius: 0.4em;
}
.accordion_review > a {
  display: flex;
  align-items: center;
  padding: 0;
  background: none;
  width: 100%;
  font-size: 1em;
  padding: 1em;
  text-decoration: none;
  transition: padding 0.15s ease-in-out;
}
.accordion_reviews.selected .accordion_review:not(.active) {
  transform: scale(0.85);
  margin: -1em 0;
}
.accordion_reviews.selected .accordion_review:not(.active) > a div span {
  display: none;
}
.accordion_reviews.selected .accordion_review:not(.active) > a figure {
  filter: blur(2px);
  opacity: 0.7;
}
.accordion_reviews.selected .accordion_review:not(.active) > a {
  padding: 0.5em 1em;
}
.accordion_reviews.selected .accordion_review {
  margin-bottom: 0;
}
.accordion_review > div {
  display: none;
  margin: -2px -2px 0;
  background: var(--color-bg);
}
.accordion_review.active {
  border-color: transparent;
  border-radius: 0.4em;
  z-index: 2;
}
.accordion_review.active > div {
  display: block;
}
.accordion_review.active > a {
  padding: 1em;
}
.accordion_review.active:after {
  background: var(--color1);
  position: absolute;
  opacity: .2;
  border-radius: 0.4em;
  content: "";
  z-index: -1;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
}
.accordion_review > a figure {
  width: 4em;
  height: 4em;
  padding: 0.5em;
  display: block;
  margin: 0;
  border-radius: 0.4em;
  margin-right: 1em;
  flex-grow: 0;
  flex-shrink: 0;
  background: white;
}
.accordion_review > a img {
  width: 3em;
  height: 3em;
  object-fit: cover;
}
.accordion_review > a div {
  flex-grow: 1;
  text-align: left;
  line-height: 1.2;
}
.accordion_review > a strong {
  display: block;
}
.accordion_review > a i {
  display: block;
  width: 1.8em;
  height: 1.8em;
  flex-shrink: 0;
  border: 2px solid;
  border-color: var(--color-border);
  background: var(--color-bg);
  border-radius: 50%;
  position: relative;
  margin-left: 0.6em;
}
.accordion_review > a i:after {
  display: block;
  width: 0.9em;
  height: 0.9em;
  position: absolute;
  content: "";
  top: 0.45em;
  left: 0.45em;
  background: linear-gradient(-135deg,var(--color1),var(--color2));
  margin: -2px;
  border-radius: 50%;
  opacity: 0;
  transform: scale(0.5);
  transition: all 0.1s ease-in-out;
}
.accordion_review > a:hover i:after {
  opacity: 0.4;
  transform: scale(0.7);
}
.accordion_review.active > a i:after {
  opacity: 1;
  transform: scale(1);
}
.accordion_review.success {
  pointer-events: none !important;
}
.accordion_review.success > a i {
  border: none;
}
.accordion_review.success > a i:after {
  opacity: 1;
  transform: scale(1);
  background-color: var(--color-success-border);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 45.7 45.7' xml:space='preserve'%3E%3Cpath fill='%23FFFFFF' d='M20.687,38.332c-2.072,2.072-5.434,2.072-7.505,0L1.554,26.704c-2.072-2.071-2.072-5.433,0-7.504 c2.071-2.072,5.433-2.072,7.505,0l6.928,6.927c0.523,0.522,1.372,0.522,1.896,0L36.642,7.368c2.071-2.072,5.433-2.072,7.505,0 c0.995,0.995,1.554,2.345,1.554,3.752c0,1.407-0.559,2.757-1.554,3.752L20.687,38.332z'/%3E%3C/svg%3E%0A");
  background-size: 60%;
  background-repeat: no-repeat;
  background-position: center;
}
.accordion_review .rating {
  border-radius: 0;
  border-bottom: 0;
  margin-bottom: 0;
}
.accordion_review textarea[name^="clio_review_description"],
.accordion_review input[name^="clio_review_subject"] {
  border-radius: 0;
}
.accordion_review textarea[name^="clio_review_description"] {
  border-radius: 0 0 2em 0.4em;
  padding-bottom: 4em;
  resize: none;
  margin-bottom: -2px;
}
.accordion_review button {
  position: absolute;
  right: 0.8em;
  bottom: 0.8em;
  padding-left: 1.5em;
  padding-right: 1.5em;
  font-size: 1.1em;
}
form.has-3colors button,
form.has-3colors .accordion_review > a i:after,
form.has-3colors .rating #rating-1:checked ~ .rating-stars label:nth-of-type(1),
form.has-3colors .rating #rating-2:checked ~ .rating-stars label:nth-of-type(-n+2),
form.has-3colors .rating #rating-3:checked ~ .rating-stars label:nth-of-type(-n+3),
form.has-3colors .rating #rating-4:checked ~ .rating-stars label:nth-of-type(-n+4),
form.has-3colors .rating #rating-5:checked ~ .rating-stars label {
  background-image: linear-gradient(-135deg, var(--color1) 0%, var(--color3) 50%, var(--color2) 100%);
}
@media screen and (max-width: 600px) {
  form { font-size: calc(var(--size) * 0.9); }
  input[type="checkbox"] + label { width: 50% }
}
@media screen and (max-width: 520px) {
  form > *.half { width: 100%; }
  input[type="checkbox"] + label { width: 100% }
  .rating-emojis { padding: 0 0.4em; }
  .rating-emojis span { display: none; }
  .rating-stars { padding: 0.8em 0.5em; }
  .accordion_review > a figure { width: 3em; height: 3em; padding: 0.25em; }
  .accordion_review > a img { width: 2.5em; height: 2.5em; }
}
@-webkit-keyframes rotating /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(-360deg);
    -o-transform: rotate(-360deg);
    transform: rotate(-360deg);
  }
}
@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(-360deg);
    -moz-transform: rotate(-360deg);
    -webkit-transform: rotate(-360deg);
    -o-transform: rotate(-360deg);
    transform: rotate(-360deg);
  }
}
</style>`;
    return style;
  }
  getCustomFields(custom) {
    let custom_html = '';
    if(typeof custom === 'object' && custom !== null) {
      for (const [key, value] of Object.entries(custom)) {
        custom_html += `<div class="${ value.mandatory ? 'required' : '' } ${ !value.full && value.type !== 'textarea' ? 'half' : '' }">
          <label for="clio_custom_${ value.id }">${ value.label }</label>`
          if(value.type == 'text') {
            custom_html += `<input type="text" placeholder="${ value.placeholder }" name="clio_custom_${ value.id }" data-validation="${ value.mandatory ? 'required' : '' }" />`
          } else if (value.type == 'textarea') {
            custom_html += `<textarea data-validation="${ value.mandatory ? 'required' : '' }" rows="5" placeholder="${ value.placeholder }" name="clio_custom_${ value.id }"></textarea>`
          } else if (value.type == 'radio') {
            custom_html += value.placeholder ? `<small>${ value.placeholder }</small>` : ''
            value.options.forEach(function(option, index) {
              custom_html += `<input data-validation="${ value.mandatory ? 'required' : '' }" type="radio" id="clio_custom_${ value.id }_${ index }" name="clio_custom_${ value.id }" value="${ option.value }"><label for="clio_custom_${ value.id }_${ index }">${ option.label }</label>`;
            })
          } else if (value.type == 'checkbox') {
            custom_html += value.placeholder ? `<small>${ value.placeholder }</small>` : ''
            value.options.forEach(function(option, index) {
              custom_html += `<input type="hidden" name="array_clio_custom_${ value.id }" value="1"/><input data-validation="${ value.mandatory ? 'required' : '' }" type="checkbox" id="clio_custom_${ value.id }_${ index }" name="clio_custom_${ value.id }" value="${ option.value }"><label for="clio_custom_${ value.id }_${ index }">${ option.label }</label>`;
            })
          } else if (value.type == 'select') {
            custom_html += `<select data-validation="${ value.mandatory ? 'required' : '' }" class="initial" name="clio_custom_${ value.id }">
              <option disabled selected value="">${ value.placeholder }</option>`
              value.options.forEach(function(option) {
                custom_html += `<option value="${ option.value }">${ option.label }</option>`;
              })
            custom_html += `</select>`
          }
        custom_html += `</div>`
      }
    }
    return custom_html
  }
  getMarkup(options, style) {
    let options_html = '';
    for (const [key, value] of Object.entries(options.subjects)) { options_html += `<option value="${key}">${value}</option>`; }
    const provinceDefault = this.getDefault('province', options.defaults, '')
    let provinceDefaultSelected = false
    let provinces_html = `<option disabled selected value="">${ options.placeholder.province }</option>`;
    for (const [key, value] of Object.entries(options.provinces)) {
      const selected = provinceDefault == value ? 'selected ' : ''
      provinces_html += `<option ${ selected }value="${ key }">${value}</option>`;
      if(selected) { provinceDefaultSelected = true }
    }
    let preferences_html = '';
    if(typeof options.preferences === 'object' && options.preferences !== null) {
      for (const [key, value] of Object.entries(options.preferences)) {
        preferences_html += `<input data-validation="${ options.optional.includes("preferences") ? '' : 'required' }" type="checkbox" id="${key}" name="clio_preferences" value="${key}"><label for="${key}">${value}</label>`;
      }
    }
    let custom_html = this.getCustomFields(options.custom);
    let accordion_review_html = this.accordionReview(options, style);
    const form = `<form class="${ style.colors.color3 ? 'has-3colors' : '' }">
  ${ options.disable.includes("firstname") ? '' : `
  <div class="half ${ options.optional.includes("firstname") ? '' : 'required' }">
    <label for="clio_first">${ options.label.firstName }</label>
    <input type="text" placeholder="${ options.placeholder.firstName }" name="clio_first" ${ this.extraAttributes('firstName', options.defaults, options.readonly) } data-validation="${ options.optional.includes("firstname") ? '' : 'required' }" />
  </div>` }
  ${ options.disable.includes("lastname") ? '' : `
  <div class="half ${ options.optional.includes("lastname") ? '' : 'required' }">
    <label for="clio_last">${ options.label.lastName }</label>
    <input type="text" placeholder="${ options.placeholder.lastName }" name="clio_last" ${ this.extraAttributes('lastName', options.defaults, options.readonly) } data-validation="${ options.optional.includes("lastname") ? '' : 'required' }" />
  </div>` }
  <div class="half required email-field">
    <label for="clio_email">${ options.label.email }</label>
    <input type="email" placeholder="${ options.placeholder.email }" name="clio_email" ${ this.extraAttributes('email', options.defaults, options.readonly) } data-validation="required email" />
  </div>
  ${ options.disable.includes("phone") ? '' : `
  <div class="half ${ options.optional.includes("phone") ? '' : 'required' }">
    <label for="clio_phone">${ options.label.phone }</label>
    <input type="tel" placeholder="${ options.placeholder.phone }" name="clio_phone" ${ this.extraAttributes('phone', options.defaults, options.readonly) } data-validation="${ options.optional.includes("phone") ? 'phone' : 'required phone' }" />
  </div>` }
  ${ options.disable.includes("birthday") ? '' : `
  <div class="half birthday ${ options.optional.includes("birthday") ? '' : 'required' }">
    <label>${ options.label.birthday }</label>
    <span>
      <input data-validation="${ options.optional.includes("birthday") ? '' : 'required day' }" placeholder="GG" type="number" step="1" name="clio_day" size="2" maxlength="2"> /
      <input data-validation="${ options.optional.includes("birthday") ? '' : 'required month' }" placeholder="MM" type="number" step="1" name="clio_month" size="2" maxlength="2"> /
      <input data-validation="${ options.optional.includes("birthday") ? '' : 'required year' }" placeholder="AAAA" type="number" step="1" name="clio_year" size="4" maxlength="4">
    </span>
  </div>` }
  ${ options.disable.includes("province") ? '' : `
  <div class="half ${ options.optional.includes("province") ? '' : 'required' }">
    <label for="clio_province">${ options.label.province }</label>
    <select data-validation="${ options.optional.includes("province") ? '' : 'required' }" name="clio_province" class="${ provinceDefaultSelected ? '' : 'initial' }">${ provinces_html }</select>
  </div>` }
  ${ !options.review || accordion_review_html ? '' : `
  <input type="hidden" name="clio_review_sku" value="${ options.product.sku }">
  <input type="hidden" name="clio_review_url" value="${ options.product.url }">
  <input type="hidden" name="clio_review_product" value="${ options.product.title }">
  <input type="hidden" name="clio_review_image" value="${ options.product.image }">
  <div class="required">
    <label for="clio_review_subject">${ options.label.review }</label>
    <input data-validation="required" type="text" placeholder="${ options.placeholder.review }" name="clio_review_subject">
    <textarea data-validation="required" rows="5" placeholder="${ options.placeholder.reviewText }" name="clio_review_description"></textarea>
  </div>
  <div class="required">
    <label for="clio_review_rating">${ options.label.rating }</label>
    <div class="input-wrap rating">
      <input id="rating-1" type="radio" name="clio_review_rating" data-validation="required" value="1">
      <input id="rating-2" type="radio" name="clio_review_rating" data-validation="required" value="2">
      <input id="rating-3" type="radio" name="clio_review_rating" data-validation="required" value="3">
      <input id="rating-4" type="radio" name="clio_review_rating" data-validation="required" value="4">
      <input id="rating-5" type="radio" name="clio_review_rating" data-validation="required" value="5">
      <div class="rating-stars">
        <label for="rating-1">&starf;</label>
        <label for="rating-2">&starf;</label>
        <label for="rating-3">&starf;</label>
        <label for="rating-4">&starf;</label>
        <label for="rating-5">&starf;</label>
      </div>
      <div class="rating-emojis">
        <div>
          <img alt="" src="${ style.images.rating_0 }" />
          <img alt="" src="${ style.images.rating_1 }" />
          <img alt="" src="${ style.images.rating_2 }" />
          <img alt="" src="${ style.images.rating_3 }" />
          <img alt="" src="${ style.images.rating_4 }" />
          <img alt="" src="${ style.images.rating_5 }" />
        </div>
        <span></span>
      </div>
    </div>
  </div>
  ` }
  ${ !options.ticket ? '' : `
    <div class="required">
      <label for="clio_subject">${ options.label.subject }</label>
      <select name="clio_subject">${ options_html }</select>
      <textarea data-validation="required" rows="5" placeholder="${ options.placeholder.description }" name="clio_description"></textarea>
    </div>` }
  ${ !preferences_html ? '' : `
  <div class="${ options.optional.includes("preferences") ? '' : 'required' }">
    <label>${ options.label.preferences }</label>
    <small>${ options.placeholder.preferences }</small>
    ${ preferences_html }
  </div>` }
  ${ custom_html }
  ${ !options.consent4 ? '' : `
  <div class="consent">
    <p>${ options.label.consent4 }</p>
    <input data-validation="required checked" id="clio_consent4_1" type="radio" name="clio_consent4" value="1"><label for="clio_consent4_1">Consento</label>
    <input data-validation="required notchecked" id="clio_consent4_0" type="radio" name="clio_consent4" value="0"><label for="clio_consent4_0">Non consento</label>
    <small>${ options.placeholder.consent4 }</small>
  </div>` }
  ${ !options.consent ? '' : `
  <div class="consent">
    <p>${ options.label.consent }</p>
    <input data-validation="required checked" id="clio_consent_1" type="radio" name="clio_consent" value="1"><label for="clio_consent_1">Consento</label>
    <input data-validation="required notchecked" id="clio_consent_0" type="radio" name="clio_consent" value="0"><label for="clio_consent_0">Non consento</label>
    <small>${ options.placeholder.consent }</small>
  </div>` }
  ${ !options.marketing ? '' : `
  <div class="consent">
    <p>${ options.label.marketing }</p>
    <input data-validation="required checked" id="clio_marketing_1" type="radio" name="clio_marketing" value="1"><label for="clio_marketing_1">Consento</label>
    <input data-validation="required notchecked" id="clio_marketing_0" type="radio" name="clio_marketing" value="0"><label for="clio_marketing_0">Non consento</label>
    <small>${ options.placeholder.marketing }</small>
  </div>` }
  ${ !options.consent3 ? '' : `
  <div class="consent">
    <p>${ options.label.consent3 }</p>
    <input data-validation="required checked" id="clio_consent3_1" type="radio" name="clio_consent3" value="1"><label for="clio_consent3_1">Accetto</label>
    <input data-validation="required notchecked" id="clio_consent3_0" type="radio" name="clio_consent3" value="0"><label for="clio_consent3_0">Non consento</label>
    <small>${ options.placeholder.consent3 }</small>
  </div>` }
  ${ accordion_review_html || `<button type="submit">${ options.label.submit }</button>` }
  <div class="result"></div>
  <div><small class="mandatory">${ options.label.mandatory }</small></div>
</form>
`;
    return form;
  }
  preload(paths) {
    let images = new Array()
    const preload = Object.values(paths)
    for(let i = 0; i < preload.length; i++) {
      images[i] = new Image()
      images[i].src = preload[i]
    }
  }
  accordionReview(options, style) {
    let reviewsHtml = ''
    const reviews = window.product_reviews
    if(!reviews) return
    const reviewedProducts = localStorage.hasOwnProperty('clioReviewedProducts') ? JSON.parse(localStorage.getItem('clioReviewedProducts')) : [];
    reviews.forEach(function(review, index) {
      const reviewedProduct = reviewedProducts.includes(review.id)
      reviewsHtml += `<div class="accordion_review${ reviewedProduct ? ' success' : '' }" data-review-product="${ review.id }">
  <a href="#">
    <figure>
      <img src="${ review.image }" />
    </figure>
    <div>
      <span>${ reviewedProduct ? options.label.reviewProductReviewed : options.label.reviewProduct }</span>
      <strong>${ review.title }</strong>
    </div>
    <i></i>
  </a>
  <script type="text/template">
    <input type="hidden" name="clio_review_sku" value="${ review.id }">
    <input type="hidden" name="clio_review_url" value="${ review.url }">
    <input type="hidden" name="clio_review_product" value="${ review.title }">
    <input type="hidden" name="clio_review_image" value="${ review.image }">
    <div class="required">
      <div class="input-wrap rating">
        <input id="rating-1" type="radio" name="clio_review_rating" data-validation="required" value="1">
        <input id="rating-2" type="radio" name="clio_review_rating" data-validation="required" value="2">
        <input id="rating-3" type="radio" name="clio_review_rating" data-validation="required" value="3">
        <input id="rating-4" type="radio" name="clio_review_rating" data-validation="required" value="4">
        <input id="rating-5" type="radio" name="clio_review_rating" data-validation="required" value="5">
        <div class="rating-stars">
          <label for="rating-1">&starf;</label>
          <label for="rating-2">&starf;</label>
          <label for="rating-3">&starf;</label>
          <label for="rating-4">&starf;</label>
          <label for="rating-5">&starf;</label>
        </div>
        <div class="rating-emojis">
          <div>
            <img alt="" src="${ style.images.rating_0 }" />
            <img alt="" src="${ style.images.rating_1 }" />
            <img alt="" src="${ style.images.rating_2 }" />
            <img alt="" src="${ style.images.rating_3 }" />
            <img alt="" src="${ style.images.rating_4 }" />
            <img alt="" src="${ style.images.rating_5 }" />
          </div>
          <span></span>
        </div>
      </div>
    </div>
    <div class="required">
      <input data-validation="required" type="text" placeholder="${ options.placeholder.review }" name="clio_review_subject">
      <textarea data-validation="required" rows="4" placeholder="${ options.placeholder.reviewText }" name="clio_review_description"></textarea>
    </div>
    <button>${ options.label.submit }</button>
  </script>
  <div></div>
</div>
`
    })
    return `
    <div>
      <p>${ options.label.reviewOrder }</p>
      <small>${ options.placeholder.reviewOrder }</small>
    </div>
    <div class="accordion_reviews">${ reviewsHtml }</div>`
  }
  accordion() {
    let wrap = this.shadowRoot
    let accordions = wrap.querySelectorAll('.accordion_review');
    let accordionsWrap = wrap.querySelector('.accordion_reviews');
    accordions.forEach(function(accordion) {
      let accordionLink = accordion.querySelector(':scope > a');
      accordionLink.addEventListener('click', function(e){
        e.preventDefault()
        accordionsWrap.classList.add('selected');
        const form = wrap.querySelector('form');
        form.classList.remove('success-accordion')
        form.querySelector('.result').innerHTML = '';
        accordions.forEach(function(accordion) {
          if(accordion.classList.contains('active')) {
            accordion.classList.remove('active')
            const accordionInputs = accordion.querySelectorAll('input, textarea')
            accordionInputs.forEach(function(accordionInput) {
              if(accordionInput.type == 'hidden') {
              } else if(accordionInput.type == 'radio') {
                if(accordionInput.checked) {
                  accordionInput.setAttribute('checked', '')
                } else {
                  accordionInput.removeAttribute('checked')
                }
              } else if(accordionInput.type == 'text') {
                accordionInput.setAttribute('value', accordionInput.value)
              } else {
                accordionInput.innerText = accordionInput.value
              }
            })
            const prevScript = accordion.querySelector(':scope > script');
            const prevWrap = accordion.querySelector(':scope > div');
            prevScript.innerHTML = prevWrap.innerHTML
            prevWrap.innerHTML = ''
          }
        })
        accordion.classList.add('active')
        const newScript = accordion.querySelector(':scope > script');
        const newWrap = accordion.querySelector(':scope > div');
        newWrap.innerHTML = newScript.innerHTML
        newScript.innerHTML = ''
      })
    })
  }
  addFonts() {
    const fonts = `<style>@font-face {
  font-family:"Revalo Modern";
  src:url("https://landing.cliomakeup.com/embed/assets/revalomodernregular.woff2") format("woff2"),url("https://landing.cliomakeup.com/embed/assets/revalomodernregular.woff") format("woff"),url("https://landing.cliomakeup.com/embed/assets/revalomodernregular.ttf") format("truetype");
  font-style:normal;font-weight:400;
}
@font-face {
  font-family:"Revalo Modern";
  src:url("https://landing.cliomakeup.com/embed/assets/revalomodernbold.woff2") format("woff2"),url("https://landing.cliomakeup.com/embed/assets/revalomodernbold.woff") format("woff"),url("https://landing.cliomakeup.com/embed/assets/revalomodernbold.ttf") format("truetype");
  font-style:normal;font-weight:600;
}
@font-face {
  font-family:"Revalo Modern";
  src:url("https://landing.cliomakeup.com/embed/assets/revalomodernblack.woff2") format("woff2"),url("https://landing.cliomakeup.com/embed/assets/revalomodernblack.woff") format("woff"),url("https://landing.cliomakeup.com/embed/assets/revalomodernblack.ttf") format("truetype");
  font-style:normal;font-weight:800;
}
</style>`;
    document.body.insertAdjacentHTML("beforeend", fonts);
  }
  printResult(form, data, options, result) {
    let success = true;
    form.classList.remove('loading');
    form.classList.add('success');
    let message = '';
    if('ticket' in data && data.ticket && 'zendesk' in data && data.zendesk) {
      message = options.result.successTicket;
      if(typeof window.fbq !== 'undefined') { window.fbq('track', 'Lead'); }
    } else if('ticket' in data && !data.ticket && 'mailchimp' in data && data.mailchimp == 200) {
      message = options.result.success;
      if(typeof window.fbq !== 'undefined') { window.fbq('track', 'Lead'); }
    } else if('serverless' in data && data.serverless && data.status) {
      message = options.result.successServerless;
      if(typeof window.fbq !== 'undefined') { window.fbq('track', 'Lead'); }
    } else {
      form.classList.remove('success');
      form.classList.add('failed');
      message = options.result.error
      success = false;
    }
    let accordionReviewsWrap = form.querySelector('.accordion_reviews')
    if(accordionReviewsWrap && success) {
      accordionReviewsWrap.classList.remove('selected')
      form.classList.remove('success');
      form.classList.add('success-accordion');
      let allProductsReviewed = true
      accordionReviewsWrap.querySelectorAll('.accordion_review').forEach(function(accordionReview){
        if(accordionReview.classList.contains('active')) {
          accordionReview.classList.add('success')
          accordionReview.classList.remove('active')
          const reviewFields = accordionReview.querySelector(':scope > div');
          const reviewLabel = accordionReview.querySelector(':scope > a span');
          reviewFields.innerHTML = ''
          reviewLabel.innerText = options.label.reviewProductReviewed
          let reviewedProducts = localStorage.hasOwnProperty('clioReviewedProducts') ? JSON.parse(localStorage.getItem('clioReviewedProducts')) : [];
          reviewedProducts.push(parseInt(accordionReview.getAttribute('data-review-product')))
          localStorage.setItem('clioReviewedProducts', JSON.stringify(reviewedProducts))
        }
        if(!accordionReview.classList.contains('success')) {
          allProductsReviewed = false
        }
      })
      message = allProductsReviewed ? options.result.successReviewOrderComplete : options.result.successReviewOrder
    }
    result.innerHTML = message.replace('$name', 'fname' in data ? data.fname : '').replace('$ticket', 'zendesk' in data ? data.zendesk : '')
  }
  initFields(inputs, result) {
    Array.prototype.forEach.call(inputs, function(input, i){
      input.addEventListener('input', function(e){
        if(e.target.value) {
          const parent = e.target.closest("div:not(.rating)")
          parent.classList.remove('error')
          parent.classList.remove('error-group')
          input.classList.remove('initial')
          result.innerHTML = ''
        }
      })
      input.addEventListener('keyup', function(e){
        if(e.target.type == 'number') {
          if(e.keyCode !== 8 && e.keyCode !== 37 && e.keyCode !== 38 && e.keyCode !== 39 && e.keyCode !== 40) {
            if(e.target.value.length == parseInt(e.target.getAttribute('maxlength'))) {
              const nextinput = e.target.nextSibling.nextSibling
              if(typeof(nextinput) != 'undefined' && nextinput != null && nextinput instanceof HTMLInputElement){ nextinput.focus() };
            }
          }
        }
      })
      input.addEventListener('keydown', function(e){
        if(e.target.type == 'number') {
          if(e.keyCode == 8 && !e.target.value) {
            const previnput = e.target.previousSibling.previousSibling
            if(typeof(previnput) != 'undefined' && previnput != null && previnput instanceof HTMLInputElement){ previnput.focus() };
          }
        }
      })
    })
  }
  submit(options){
    let main = this
    let wrap = this.shadowRoot
    let form = wrap.querySelector('form');
    let inputs = form.querySelectorAll('[data-validation]');
    let result = form.querySelector('.result');
    main.initFields(inputs, result)
    let validations = {
      required: function(el){
        if(el.type == "radio" || el.type == "checkbox") {
          let radios = wrap.querySelectorAll('input[name="'+el.name+'"]');
          let valid = false;
          Array.prototype.forEach.call(radios, function(radio, i){ if(radio.checked) { valid = true; } })
          return valid
        } else {
          return el.value !== '';
        }
      },
      checked: function(el){ return el.checked },
      notchecked: function(el){ return !el.checked },
      day: function(el) { return el.value.match(/^([1-9]|0[1-9]|1[0-9]|2[0-9]|3[01])$/); },
      month: function(el) { return el.value.match(/^([1-9]|0[1-9]|1[012])$/); },
      year: function(el) { return el.value.match(/^(19[0-9][0-9]|20[012][0-9])$/); },
      //phone: function(el){ return el.value.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im); },
      phone: function(el){ return el.value.match(/^[0-9]{6,15}$/); },
      email: function(el){ return el.value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);}
    }
    let handleErrors = function(response) {
      if (!response.ok) { throw Error(response.statusText); }
      return response.json();
    }
    form.addEventListener("submit", function(e) {
      e.preventDefault();
      let errors = false;
      let accordionInputs = form.querySelectorAll('.accordion_review [data-validation]');
      if(accordionInputs) { main.initFields(accordionInputs, result) }
      let allInputs = accordionInputs ? [...inputs, ...accordionInputs] : inputs;
      Array.prototype.forEach.call(allInputs, function(input, i){
        let attr = input.getAttribute('data-validation')
        let rules = attr ? attr.split(' ') : ''
        let parent = input.closest("div:not(.rating)")
        let valid = true;
        if(!rules.includes('required') && !input.value) {
          //skip validation
        } else {
          Array.prototype.forEach.call(rules, function(rule, i){
            if(valid) {
              if(!validations[rule](input)) {
                parent.classList.add('error')
                parent.classList.add('error-group')
                errors = true;
                valid = false;
              } else {
                if(!parent.classList.contains('error-group')) {
                  parent.classList.remove('error')
                }
              }
            }
          })
        }
      })
      if(errors) {
        let firsterror = form.querySelector('.error input, .error select, .error textarea')
        result.innerHTML = firsterror.name == 'clio_marketing' || firsterror.name == 'clio_consent' || firsterror.name == 'clio_consent3' || firsterror.name == 'clio_consent4' ? options.result.validation_privacy : options.result.validation
        firsterror.focus()
        return false
      }
      if((!form.classList.contains('loading'))&&(!form.classList.contains('success'))) {
        form.classList.add('loading');
        form.classList.remove('success', 'failed');
        result.innerHTML = options.result.loading;
        let submiturl = options.serverless ? options.endpoint.aws : options.endpoint.server;
        let headers = {
          'Accept': 'application/json; charset=utf-8',
          'Content-type': 'application/json; charset=UTF-8'
        }
        let tokenRequest = { token: 6 };
        //build data object
        let finalRequest = Object.fromEntries(new FormData(form))
        let checkboxes = form.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(function(checkbox){
          if(checkbox.checked) {
            if(Array.isArray(finalRequest[checkbox.name])) {
              finalRequest[checkbox.name].push(checkbox.value)
            } else {
              finalRequest[checkbox.name] = [ checkbox.value ]
            }
          }
        })
        finalRequest.tag = options.tag
        finalRequest.ticket = options.ticket
        finalRequest.review = options.review
        fetch(submiturl, {
          method: 'POST',
          body: JSON.stringify(options.serverless ? finalRequest : tokenRequest),
          headers: headers
        }).then(handleErrors).then(function(data) {
          if('token' in data) {
            finalRequest.token = data.token
            fetch(submiturl, {
              method: 'POST',
              body: JSON.stringify(finalRequest),
              headers: headers
            }).then(handleErrors).then(function(data) {
              main.printResult(form, data, options, result)
            }).catch(function(error) {
              main.printResult(form, { error: error }, options, result)
            });
          } else {
            main.printResult(form, data, options, result)
          }
        }).catch(function(error) {
          main.printResult(form, { error: error }, options, result)
        });
      }
    });
  }
}
customElements.define("clio-widget-form", ClioWidgetForm);